import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../lib/metaPixel";

/**
 * MetaPixelTracker component
 * Listens for client-side pathname changes within React Router
 * and triggers deduplicated Meta Pixel PageView events.
 */
export default function MetaPixelTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
